<template>
  <div class="qw-disdetail">
    <van-skeleton
      v-if="!firstloading"
      title
      :row="5"
      style="background-color:#fff;padding:20px"
    />
    <div v-else class="form-body">
      <div class="form-row">
        <div class="form-row-title">
          {{ GetDescInfo.namelable }}
          <span class="small"></span>
        </div>
        <van-field
          v-model="dis.channel_name"
          :placeholder="'请输入' + GetDescInfo.namelable"
          border
        />
      </div>
      <div class="form-row">
        <div class="form-row-title">
          {{ GetDescInfo.useuser }}
          <span class="small">{{ GetDescInfo.useuserdesc }}</span>
        </div>
        <van-field
          v-if="useuser.loading"
          :placeholder="'请' + GetDescInfo.useuser"
          readonly
          clickable
          @click="seluseuserEvent"
          :value="getUserName"
        />
        <div class="loading-field" v-else>
          加载中...
          <van-loading />
        </div>
      </div>
      <div class="form-row" v-if="!isdefault">
        <div class="form-row-title">
          自动通过好友
          <span class="small"
            >开启后，客户通过此二维码扫码加您好友无需您同意</span
          >
        </div>
        <van-switch v-model="dis.auto_firend" />
      </div>
      <!-- <div class="form-row" v-if="!isdefault">
        <div class="form-row-title">自动打招呼<span class="small"></span></div>
        <van-switch v-model="dis.auto_sayhi" />
      </div>
      <div class="form-row" v-if="dis.auto_sayhi">
        <div class="form-row-title">打招呼内容<span class="small"></span></div>
        <van-tabs
          v-model="hi_content_tab"
          style="border:1px solid #ebedf0; background-color:#fafafa"
        >
          <van-tab title="文字" name="a" class="pd15">
            <div class="form-row">
              <div class="form-row-title">
                文本内容<span class="small"></span>
              </div>
              <van-field
                v-model="dis.hi_content.text.content"
                rows="2"
                type="textarea"
                maxlength="500"
                placeholder="请输入打招呼的内容"
                show-word-limit
                border
              />
            </div>
          </van-tab>
          <van-tab title="文字+图片" name="b" class="pd15">
            <div class="form-row">
              <div class="form-row-title">
                文本内容<span class="small">若不输入，则只回复图片</span>
              </div>
              <van-field
                v-model="dis.hi_content.text.content"
                rows="2"
                type="textarea"
                maxlength="500"
                placeholder="请输入打招呼的内容"
                show-word-limit
                border
              />
            </div>
            <div class="form-row">
              <div class="form-row-title">
                图片内容<span class="small"></span>
              </div>
              <van-uploader
                name="imager_vantuploader"
                :before-read="beforeRead"
                :after-read="afterRead"
                v-model="image_vant"
                :max-count="1"
              />
            </div>
          </van-tab>
          <van-tab title="文字+图文链接" name="c" class="pd15">
            <div class="form-row">
              <div class="form-row-title">
                文本内容<span class="small">若不输入，则只回复图文链接</span>
              </div>
              <van-field
                v-model="dis.hi_content.text.content"
                rows="2"
                type="textarea"
                maxlength="500"
                placeholder="请输入打招呼的内容"
                show-word-limit
                border
              />
            </div>
            <div class="form-row">
              <div class="form-row-title">
                图文链接标题<span class="small"></span>
              </div>
              <van-field
                v-model="dis.hi_content.link.title"
                placeholder="请输入链接标题"
                border
              />
            </div>
            <div class="form-row">
              <div class="form-row-title">
                图文链接描述<span class="small"></span>
              </div>
              <van-field
                v-model="dis.hi_content.link.desc"
                placeholder="请输入图文链接描述"
                border
              />
            </div>
            <div class="form-row">
              <div class="form-row-title">
                图文链接小图标<span class="small"></span>
              </div>
              <van-uploader
                name="link_vantuploader"
                :before-read="beforeRead"
                :after-read="afterRead"
                :max-count="1"
                v-model="link_vant"
              />
            </div>
            <div class="form-row">
              <div class="form-row-title">
                图文链接地址<span class="small"></span>
              </div>
              <van-field
                v-model="dis.hi_content.link.url"
                placeholder="请输入图文链接地址"
                border
              />
            </div>
          </van-tab>
        </van-tabs>
      </div>-->
      <div class="form-row">
        <div class="form-row-title">
          自动打标签
          <span class="small"></span>
        </div>
        <van-switch v-model="dis.auto_tab" />
      </div>
      <div class="form-row" v-if="dis.auto_tab">
        <div class="form-row-title">
          标签内容
          <span class="small"></span>
        </div>
        <van-field
          readonly
          clickable
          :value="getTabName"
          placeholder="点击选择标签内容"
          @click="userTabs_sel = true"
        />
      </div>

      <div class="form-row">
        <div class="form-warning">
          <img src="../../static/images/icon/icon-warning-h.png" alt />
          因企业微信限制，若您的企业已经在"企业微信后台"配置了欢迎语，这里的入群引导和进群二维码将不会生效
          <a
            href="javascript:void(0);"
            @click="preview(require('../../static/images/help-autohi.png'))"
            >查看解释</a
          >
        </div>
        <div class="form-row-title">
          入群引导语
          <span class="small"></span>
        </div>
        <hitext v-model="dis.hi_content.text.content" maxlength="500"></hitext>
        <!-- <van-field
          v-model="dis.hi_content.text.content"
          rows="3"
          type="textarea"
          maxlength="500"
          placeholder="请输入入群引导语"
          show-word-limit
          border
        /> -->
      </div>
      <div class="form-row">
        <div class="form-row-title">
          邀请入群方式
          <span class="small"></span>
        </div>
        <div class="form-row-grouptype">
          <div
            :class="
              'grouptype-item' +
                (dis.hi_content.invitetype != 1 ? ' active' : '')
            "
            @click="dis.hi_content.invitetype = 0"
          >
            <div class="grouptype-title">群二维码</div>
            <img
              class="grouptype-image"
              src="../../static/images/sendtype1.jpg"
              alt=""
              srcset=""
            />
            <img
              class="checked-image"
              src="../../static/images/icon/icon-checked.png"
              alt=""
              srcset=""
            />
          </div>
          <div
            :class="
              'grouptype-item' +
                (dis.hi_content.invitetype == 1 ? ' active' : '')
            "
            @click="dis.hi_content.invitetype = 1"
          >
            <div class="grouptype-title">加群链接</div>
            <img
              class="grouptype-image"
              src="../../static/images/sendtype2.jpg"
              alt=""
              srcset=""
            />
            <img
              class="checked-image"
              src="../../static/images/icon/icon-checked.png"
              alt=""
              srcset=""
            />
          </div>
        </div>
      </div>
      <div class="form-row" v-if="dis.hi_content.invitetype == 1">
        <div class="form-row-title">
          群二维码类型
          <span class="small"></span>
        </div>
        <van-radio-group
          v-model="dis.hi_content.qrcodetype"
          @change="onChangeQrcodeType"
        >
          <van-radio name="1">普通群二维码(7天过期，需自行更换)</van-radio>
          <van-radio name="2"
            >企业微信官方群活码（永不过期，总人数为上传数量×1000人）
            <a
              href="https://www.huobanmao.com/new/4036.html"
              target="_blank"
              class="helplink"
              >如何获取？</a
            ></van-radio
          >
        </van-radio-group>
      </div>
      <div class="form-row">
        <div class="form-row-title">
          单个二维码扫描数量上限
          <span class="small"></span>
        </div>
        <van-field
          v-model="dis.hi_content.maxpcount"
          type="digit"
          placeholder="请输入单个二维码扫描数量上限"
          border
        />
      </div>
      <div class="form-row">
        <div class="form-row-title">
          进群二维码
          <span class="small"
            >可以上传多张，单张二维码达到扫码上限后自动切换到下一张</span
          >
        </div>
        <div class="form-row-content">
          <vuedraggable
            class="wrapper"
            :options="{ animation: 300 }"
            v-model="image_vant"
          >
            <transition-group>
              <div
                class="v-image-item"
                v-for="(img, i) in image_vant"
                v-bind:key="img.name"
                @click="vantimg_action_event(i)"
                @touchstart="vantimg_action_event_start(i)"
                @touchend="vantimg_action_event_end(i)"
              >
                <van-image
                  width="115px"
                  height="115px"
                  fit="cover"
                  :src="img.content ? img.content : img.url"
                />
                <div class="v-image-zz" v-show="img.status"></div>
                <div class="v-image-cnt" v-show="img.status == 'uploading'">
                  <van-loading size="20px" />
                </div>
                <div class="v-image-cnt" v-show="img.status == 'failed'">
                  <div class="v-image-cnt-actions">
                    <van-icon name="warning-o" />
                  </div>
                  <div class="v-image-cnt-text" v-show="img.message">
                    {{ img.message }}
                  </div>
                </div>
                <!-- <div class="v-image-cnt1">
                  <div class="v-image-cnt-text">
                    使用108
                  </div>
                  <van-icon name="setting-o" />
                </div> -->
                <div
                  class="v-image-cnt3"
                  v-show="img.status != 'uploading'"
                ></div>
                <div
                  class="v-image-cnt3-centent"
                  v-show="img.status != 'uploading'"
                >
                  已使用{{ img.pushcount ? img.pushcount : 0 }}
                </div>
                <div class="v-image-cnt2" v-show="img.status != 'uploading'">
                  操作
                </div>
              </div>
            </transition-group>
          </vuedraggable>

          <van-uploader
            name="imager_vantuploader"
            :before-read="beforeRead"
            :after-read="afterRead"
            :max-count="500"
            :multiple="true"
          >
            <div class="v-image-add">
              <van-icon name="plus" />
            </div>
          </van-uploader>
        </div>
      </div>

      <!-- <div class="form-row">
        <div class="form-row-title">
          备用二维码
          <span class="small">当以上群二维码全部失效后发送备用二维码</span>
        </div>
        
        <van-uploader
          name="imager_vantuploader"
          :before-read="beforeRead"
          :after-read="afterRead"
          v-model="image_vant"
          :max-count="1"
        />
      </div>-->
      <van-button
        type="info"
        :loading="loading_qrc"
        loading-text="数据提交中..."
        block
        style="margin-top:20px"
        @click="DownLoadQrCode"
        v-if="!isdefault"
        >保存并下载二维码</van-button
      >
      <van-button
        type="primary"
        block
        style="margin-top:15px"
        @click="SubData"
        :loading="loading_sub"
        loading-text="数据提交中..."
        >{{ GetDescInfo.btnsublable }}</van-button
      >
    </div>
    <van-popup
      v-model="userTabs_sel"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <wx_tags :userTabs="userTabs" v-if="userTabs_sel"></wx_tags>
    </van-popup>
    <van-popup
      v-model="useuser_sel"
      position="bottom"
      :style="{ height: '70%' }"
    >
      <wx_users :useuser="useuser" v-if="useuser_sel && !hasdept"></wx_users>
      <wx_usersn :useuser="useuser" v-if="useuser_sel && hasdept"></wx_usersn>
    </van-popup>
    <!-- <van-popup
      v-model="useuser_sel"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <van-picker
        show-toolbar
        :columns="useuser_data"
        @cancel="useuser_sel = false"
        @confirm="useuser_sel_confirm"
      />
    </van-popup>-->
    <van-action-sheet
      v-model="vantimg_action_show"
      :actions="vantimg_actions"
      cancel-text="取消"
      close-on-click-action
      @select="vantimg_action_select"
    />
    <van-popup v-model="vantimg_action_edit_popup">
      <div
        class="edit-popup-box"
        v-if="image_vant && image_vant.length > 0 && vantimg_action_edit_popup"
      >
        <div class="edit-popup-image">
          <van-image
            width="80vw"
            height="80vw"
            fit="cover"
            :src="
              image_vant[vantimg_action_index].content
                ? image_vant[vantimg_action_index].content
                : image_vant[vantimg_action_index].url
            "
          />
          <div
            class="v-image-zz"
            v-show="image_vant[vantimg_action_index].status"
          ></div>
          <div
            class="v-image-cnt"
            v-show="image_vant[vantimg_action_index].status == 'uploading'"
          >
            <van-loading size="60px" />
          </div>
          <div
            class="v-image-cnt"
            v-show="image_vant[vantimg_action_index].status == 'failed'"
          >
            <div class="v-image-cnt-actions">
              <van-icon name="warning-o" />
            </div>
            <div
              class="v-image-cnt-text"
              v-show="image_vant[vantimg_action_index].message"
            >
              {{ image_vant[vantimg_action_index].message }}
            </div>
          </div>
        </div>

        <div class="edit-popup-actions">
          <van-uploader
            name="imager_vantpopup"
            :before-read="beforeRead"
            :after-read="afterReadReload"
            :max-count="1"
          >
            <button class="edit-popup-action edit-popup-action-main">
              <van-icon name="photo-o" /> 更换二维码
            </button>
          </van-uploader>

          <button
            class="edit-popup-action edit-popup-action-sub"
            @click="vantimg_action_edit_popup = false"
          >
            取消
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import vuedraggable from "vuedraggable";
import config from "@/config";
import wx_tags from "./Tags";
import wx_usersn from "./SelUserN";
import wx_users from "./SelUser";
import Vue from "vue";
import { newname } from "@/util/crypto";
import { htmlfilter } from "@/util/htmlfilter";
import { ImagePreview } from "vant";
import QrcodeDecoder from "qrcode-decoder";
import hitext from "../components/hitext";
import {
  Button,
  Field,
  Switch,
  Picker,
  Popup,
  Tabs,
  Tab,
  Panel,
  Uploader,
  Toast,
  Skeleton,
  Dialog,
  Loading,
  ActionSheet,
} from "vant";
Vue.use(Button);
Vue.use(Field);
Vue.use(Switch);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Panel);
Vue.use(Uploader);
Vue.use(Toast);
Vue.use(Skeleton);
Vue.use(Dialog);
Vue.use(Loading);
Vue.use(ActionSheet);
export default {
  name: "qd-disdetail",
  data() {
    return {
      vantimg_action_edit_popup: false,
      vantimg_action_show: false,
      vantimg_actions: [
        { name: "重新上传" },
        { name: "删除Ta" },
        // { name: '重置使用数为0', subname: '当前使用0' },
      ],
      vantimg_action_desc: "当前使用数10次",
      vantimg_action_index: 0,
      vantimg_action_event_time: 0,
      firstloading: false,
      dis: {
        channel_name: "",
        auto_firend: 1,
        auto_sayhi: 1,
        useuser: "",
        tab_content: [],
        hi_content: {
          text: {
            content: "",
          },
          image: {
            media_path: "",
          },
          link: {
            title: "",
            picurl: "",
            desc: "",
            url: "",
          },
          maxpcount: 200,
        },
        auto_tab: 1,
      },
      //图文消息图片
      image_vant: [],
      //图文链接图片
      link_vant: [],
      //显示使用人下拉框
      useuser_sel: false,
      useuser_data: [],
      useuser: {
        datas: [],
        seldatas: [],
        closeModal: function() {},
        loading: false,
      },
      //打招呼方式
      hi_content_tab: "a",
      //标签相关
      userTabs: {
        seltag: [],
        datas: [],
        confimEvent: function() {},
      },

      userTabs_sel: false,
      //渠道ID
      channelid: 0,
      channelno: "",
      isdefault: false,
      loading_sub: false,
      loading_qrc: false,
      channeltype: 2,

      hasdept: false,
    };
  },
  watch: {
    vantimg_action_show: function(val) {
      console.log("vantimg_action_show val", val);
    },
    "dis.hi_content.maxpcount": function(val) {
      var t = this;
      if (val && val >= 0 && t.image_vant && t.image_vant.length > 0) {
        t.reload_upload_status(val);
      }
      console.log("dis.hi_content.maxpcount 产生了变化", val);
      console.log("t.image_vant", t.image_vant);
    },
  },
  methods: {
    //修改码的类型
    onChangeQrcodeType(item) {
      var t = this;
      switch (item) {
        case "1":
          if (t.dis.hi_content.maxpcount == 950) {
            t.dis.hi_content.maxpcount = 190;
          }
          break;
        case "2":
          if (t.dis.hi_content.maxpcount == 190) {
            t.dis.hi_content.maxpcount = 950;
          }
          break;
        default:
          break;
      }
      console.log("qrcodetype", item);
    },
    preview(url) {
      ImagePreview({
        images: [url],
        closeable: true,
        closeOnPopstate: true,
      });
    },
    //获得部门下的所有部门
    getDeptObj(deptid) {
      var t = this;
      deptid = deptid || 1;
      this.$http
        .get("/Firm/GetDeptObj", { deptid: deptid || 1 }, 2)
        .then((res) => {
          if (res.resultState == 1) {
            t.hasdept = true;
          }
        })
        .catch((error) => {});
    },
    onmove() {
      console.log("11111");
    },
    reload_upload_status(val) {
      var t = this;
      for (let index = 0; index < t.image_vant.length; index++) {
        if (
          t.image_vant[index].pushcount >= val &&
          t.image_vant[index].status != "uploading"
        ) {
          t.image_vant[index].status = "failed";
          t.image_vant[index].message = "已失效";
          t.image_vant[index].isexp = true;
        }
        if (
          t.image_vant[index].pushcount < val &&
          t.image_vant[index].status == "failed"
        ) {
          t.image_vant[index].status = "";
          t.image_vant[index].message = "";
          t.image_vant[index].isexp = false;
        }
      }
    },
    //显示二维码操作
    vantimg_action_event(index) {
      var t = this;
      console.log("vantimg_action_event");
      if (!t.vantimg_action_show) {
        t.vantimg_action_index = index;
        t.vantimg_action_show = true;
      }
    },
    //显示二维码操作（兼容手机）
    vantimg_action_event_start(index) {
      console.log("vantimg_action_event_start");
      this.vantimg_action_event_time = new Date().getTime();
    },
    vantimg_action_event_end(index) {
      console.log("vantimg_action_event_end");
      var t = this;
      if (new Date().getTime() - this.vantimg_action_event_time <= 100)
        setTimeout(() => {
          t.vantimg_action_event(index);
        }, 50);
    },
    //点击选择某个菜单
    vantimg_action_select(action, index) {
      var t = this;
      console.log("vantimg_action_select action", action);
      console.log("vantimg_action_select index", index);
      console.log("t.vantimg_action_index", t.vantimg_action_index);
      if (index == 0) {
        t.vantimg_action_show = false;
        t.vantimg_action_edit_popup = true;
      } else if (index == 1 && t.image_vant.length > t.vantimg_action_index) {
        t.image_vant.splice(t.vantimg_action_index, 1);
      }
      console.log("t.image_vant", t.image_vant);
    },
    //图片过大
    overSize(e) {
      console.log("overSize", overSize);
    },
    //图片格式校验
    beforeRead(file) {
      console.log("beforeRead", file);
      console.log("file type", typeof file);
      console.log("file length", file.length);
      var beforeRead_ = (file) => {
        var ret_ = true;
        if (file.size > 4 * 1024 * 1024) {
          Toast("图片大小不能超过4M");
          ret = false;
        }
        if (file.type.indexOf("image") < 0) {
          Toast("只能上传图片格式");
          ret = false;
        }
        return ret;
      };
      var ret = true;
      if (file.length && file.length > 0) {
        for (let i = 0; i < file.length; i++) {
          ret = beforeRead_(file[i]);
          if (!ret) break;
        }
      } else ret = beforeRead_(file);
      return ret;
    },
    afterRead_(file_obj) {
      var t = this;
      return new Promise((resolve, reject) => {
        var file = file_obj.file;
        //更换一个随机名称
        var suffix = ".jpg";
        if (file.name.lastIndexOf(".") >= 0)
          suffix = file.name.substr(file.name.lastIndexOf("."));
        var filename = `${newname()}${suffix}`;
        //开始上传
        t.cos_upload(
          //文件保存的路径和名称
          `/${filename}`,
          //文件内容
          file,
          //上传成功后回调函数
          function(err, res) {
            let qr = new QrcodeDecoder();

            if (err) {
              file_obj.status = "failed";
              file_obj.message = "上传失败";
            } else {
              file_obj.status = "";
              file_obj.url = res.Location;
              file_obj.path = res.path;
              // if(detail.name=="imager_vantuploader") t.dis.hi_content.image.media_path = res.Location;
              // else t.dis.hi_content.link.picurl = res.Location;
            }
            qr.decodeFromImage(file_obj.content)
              .then((res) => {
                console.log("decodeFromImage", res);
                if (res) file_obj.ercode = res.data;
                resolve(file_obj);
              })
              .catch(() => {
                resolve(file_obj);
              });
          },
          //上传进度更新函数
          function(res) {
            console.log("当前进度：", res);
          }
        );
      });
    },
    //上传图片
    async afterRead(file_obj_, detail) {
      var t = this;
      console.log("file_obj", file_obj_);
      console.log("detail", detail);
      // setTimeout(() => {
      //   t.afterRead_(file_obj_);
      // }, 6000);
      if (file_obj_.length && file_obj_.length > 0) {
        for (let index = 0; index < file_obj_.length; index++) {
          file_obj_[index].name = newname();
          t.image_vant.push(file_obj_[index]);
          file_obj_[index].status = "uploading";
        }
        for (let index = 0; index < file_obj_.length; index++) {
          file_obj_[index] = await t.afterRead_(file_obj_[index]);
        }
      } else {
        file_obj_.name = newname();
        t.image_vant.push(file_obj_);
        file_obj_.status = "uploading";
        await t.afterRead_(file_obj_);
      }
    },
    //重新上传图片
    async afterReadReload(file_obj_, detail) {
      var t = this;
      t.image_vant[t.vantimg_action_index].status = "uploading";
      t.image_vant[t.vantimg_action_index].content = file_obj_.content;
      var file_res = await t.afterRead_(file_obj_);
      t.image_vant[t.vantimg_action_index].status = file_res.status;
      if (!file_res.status) {
        t.vantimg_action_edit_popup = false;
        t.image_vant[t.vantimg_action_index].url = file_res.url;
        t.image_vant[t.vantimg_action_index].oldpath =
          t.image_vant[t.vantimg_action_index].path;
        t.image_vant[t.vantimg_action_index].path = file_res.path;
        t.image_vant[t.vantimg_action_index].ercode = file_res.ercode;
      }

      t.reload_upload_status(t.dis.hi_content.maxpcount);
    },
    //点击选择使用人
    seluseuserEvent() {
      this.useuser_sel = true;
      this.useuser.isdefault = this.isdefault;
    },
    //确认选择使用人
    useuser_sel_confirm(value) {
      var t = this;
      t.useuser_sel = false;
      t.dis.useuser = value;
    },
    //获得拥有外部联系权限的用户信息
    GetFollowUserList() {
      var t = this;
      var useuser_data = [];
      this.$http
        .get("/Channel/GetFollowUserInfoList", {}, 2)
        .then((res) => {
          t.useuser.loading = true;
          if (res.resultState == 1) {
            // useuser_data = useuser_data.concat(res.Data);
            // t.useuser_data = useuser_data;
            t.useuser.datas = res.Data;
          }
        })
        .catch((error) => {});
    },
    //获得渠道信息
    GetChannelDetail() {
      var t = this;
      this.$http
        .get("/Channel/GetChannelDetail", { channelid: t.channelid }, 2)
        .then((res) => {
          t.firstloading = true;
          console.log("res", JSON.stringify(res));
          if (res.resultState == 1) {
            t.FormatChannelDetail(res);
          } else Toast(res.errorMsg);
        })
        .catch((error) => {});
    },

    //获得渠道信息
    GetChannelDetailByNo(channelno) {
      var t = this;
      this.$http
        .get("/Channel/GetChannelDetailByNo", { channelno: t.channelno }, 2)
        .then((res) => {
          t.firstloading = true;
          console.log("res", JSON.stringify(res));
          if (res.resultState == 1) {
            t.FormatChannelDetail(res);
          } else Toast(res.errorMsg);
        })
        .catch((error) => {});
    },
    FormatChannelDetail(res) {
      var t = this;
      var has_img = 1;
      var has_link = 1;
      var dis = res.Data;
      dis.hi_content = JSON.parse(dis.hi_content);
      if (!dis.hi_content.text) dis.hi_content.text = { content: "" };
      if (!dis.hi_content.image) {
        has_img = 0;
        dis.hi_content.image = {
          media_path: "",
        };
      }
      if (!dis.hi_content.link) {
        has_link = 0;
        dis.hi_content.link = {
          title: "",
          picurl: "",
          desc: "",
          url: "",
          default: 1,
        };
      }
      if (!dis.hi_content.maxpcount) dis.hi_content.maxpcount = 190;
      if (!dis.hi_content.invitetype) dis.hi_content.invitetype = 0;
      if (!dis.hi_content.qrcodetype) dis.hi_content.qrcodetype = "1";
      else dis.hi_content.qrcodetype = dis.hi_content.qrcodetype.toString();
      t.image_vant = [];
      if (dis.hi_content.groupqrcodes) {
        for (
          let index = 0;
          index < dis.hi_content.groupqrcodes.length;
          index++
        ) {
          dis.hi_content.groupqrcodes[index].name = newname();
          dis.hi_content.groupqrcodes[index].oldpath =
            dis.hi_content.groupqrcodes[index].path;
        }
        t.image_vant = dis.hi_content.groupqrcodes;
      }

      if (has_link == 1) {
        t.hi_content_tab = "c";
        t.link_vant = [
          {
            url: `${config.img_host}${dis.hi_content.link.picurl}`,
            status: "",
            message: "",
            path: dis.hi_content.link.picurl,
          },
        ];
      }

      try {
        dis.hi_content.text.content = decodeURIComponent(dis.hi_content.text.content||"");
      } catch (error) {
        console.log("decode error",error)
      }
      


      dis.tab_content = JSON.parse(dis.tab_content);
      t.useuser.seldatas = JSON.parse(dis.useuser || "[]");
      t.userTabs.seltag = dis.tab_content;
      if (t.isdefault) dis.auto_sayhi = true;
      console.log("dis.channelid", dis.channelid);
      if (dis.channelid <= 0) dis.auto_firend = true;
      t.dis = dis;
    },
    //获得企业外部联系人所有标签
    GetAllClientTags() {
      var t = this;
      t.$http
        .get("/Channel/GetAllClientTags", {}, 2)
        .then((res) => {
          var usertabs = [];
          if (res.resultState == 1) {
            usertabs = res.Data;
          }
          t.userTabs.datas = usertabs;
        })
        .catch((error) => {});
    },
    //保存数据
    SubData(callback) {
      var t = this;
      if (!t.loading_sub) {
        var params = JSON.parse(JSON.stringify(t.dis));
        console.log("SubData params", params);
        if (!t.useuser.seldatas || t.useuser.seldatas.length <= 0) {
          Toast("请选择指定使用人");
          return;
        }
        params.auto_sayhi = true;
        var hi_content = params.hi_content;
        if (
          !hi_content.text ||
          !hi_content.text.content ||
          hi_content.text.content.length <= 0
        ) {
          Toast("请输入入群引导语");
          return;
        }
        var htmlfilter_text = htmlfilter(hi_content.text.content);
        if (htmlfilter_text.length > 600) {
          Toast("入群引导语过长");
          return;
        }
        if (!hi_content.maxpcount || hi_content.maxpcount <= 0) {
          Toast("请设置每个群二维码最多拉的客户数");
          return;
        }
        if (t.image_vant.length <= 0) {
          Toast("请上传进群二维码");
          return;
        }
        var image_upload_status = true;
        for (let index = 0; index < t.image_vant.length; index++) {
          const element = t.image_vant[index];
          if (element.status == "uploading") {
            Toast("有进群二维码未上传成功，请稍等");
            image_upload_status = false;
            break;
          }
          if (element.status == "failed" && !element.isexp) {
            Toast("有进群二维码上传失败，请删除重新上传");
            image_upload_status = false;
            break;
          }
        }
        if (!image_upload_status) return;
        params.hi_content.text.content = encodeURIComponent(params.hi_content.text.content||"");
        params.hi_content.groupqrcodes = [];
        // console.log("image_vant",t.image_vant)
        for (let index = 0; index < t.image_vant.length; index++) {
          const element = t.image_vant[index];
          params.hi_content.groupqrcodes.push({
            path: element.path,
            oldpath: element.oldpath,
            status: element.status,
            url: element.url,
            id: element.id,
            ercode: element.ercode,
            timenotch: element.timenotch,
          });
        }
        console.log(
          "params.hi_content.groupqrcodes",
          params.hi_content.groupqrcodes
        );

        if (params.hi_content.invitetype != 1) params.hi_content.qrcodetype = 1;

        params.useuser = JSON.stringify(t.useuser.seldatas);
        params.tab_content = JSON.stringify(t.userTabs.seltag);
        params.hi_content = JSON.stringify(params.hi_content);
        params.isdefault = t.isdefault;
        params.channeltype = t.channeltype;
        t.loading_sub = true;
        t.$http
          .post("/Channel/SaveChannel", params, 2)
          .then((res) => {
            t.loading_sub = false;
            if (res.resultState == 1) {
              t.dis.channelid = res.Data;
              if (typeof callback == "function") callback();
              else this.$router.back(-1);
            } else Toast(res.errorMsg);
          })
          .catch((error) => {
            t.loading_sub = false;
            Toast("网络异常，请稍后重试");
          });
      }
    },
    //下载二维码
    DownLoadQrCode() {
      var t = this;
      t.SubData(() => {
        t.$router.push({
          path: "/qrcode",
          query: { id: t.dis.channelid },
        });
      });
    },
  },
  components: { wx_tags, wx_users, wx_usersn, vuedraggable, hitext },
  computed: {
    getTabName() {
      var t = this;
      var ret = "";
      for (let i = 0; i < t.userTabs.seltag.length; i++) {
        for (let j = 0; j < t.userTabs.datas.length; j++) {
          for (let s = 0; s < t.userTabs.datas[j].tag.length; s++) {
            if (t.userTabs.datas[j].tag[s].id == t.userTabs.seltag[i]) {
              ret += `[${t.userTabs.datas[j].group_name}]${t.userTabs.datas[j].tag[s].name}`;
              break;
            }
          }
        }
        if (i < t.userTabs.seltag.length - 1) ret += "，";
      }
      return ret;
    },
    getUserName() {
      var t = this;
      var ret = "";
      if (t.useuser.seldatas) {
        for (let i = 0; i < t.useuser.seldatas.length; i++) {
          var userinfo = t.useuser.datas.find(
            (item) => item.userid == t.useuser.seldatas[i]
          );
          console.log("userinfo", userinfo);
          if (userinfo) ret += userinfo.name;
          if (i < t.useuser.seldatas.length - 1) ret += "，";
        }
      }
      return ret;
    },
    //获得字段应该显示的名称
    GetDescInfo() {
      console.log("this.isdefault", this.isdefault);
      var ret = {
        namelable: "拉群二维码名称",
        btnsublable: "保存配置",
        useuser: "选择指定使用人",
        useuserdesc: "",
      };

      return ret;
    },
  },
  created() {
    var t = this;
    console.log("query", t.$route.query);
    if (t.$route.query.id) t.channelid = t.$route.query.id;
    if (t.$route.query.no) t.channelno = t.$route.query.no;
    if (t.$route.query.isdefault) t.isdefault = t.$route.query.isdefault;
    // if (t.$route.query.type) t.channeltype = t.$route.query.type;
    t.getDeptObj(0);
    t.$http
      .get("/Firm/GetConfig", {}, 2)
      .then((res) => {
        if (res.resultState == 1) {
          if (!res.Data.Secret) {
            Dialog.confirm({
              title: "系统提示",
              message: "未进行开发配置，需要先配置才能正常创建建群二维码哦~",
              confirmButtonText: "现在去设置",
              cancelButtonText: "一会再去",
            })
              .then(() => {
                console.log("confirm success");
                window.location.href = "./#/?page=corsettle";
              })
              .catch(() => {
                t.GetFollowUserList();
                t.GetChannelDetail();
                t.GetAllClientTags();
              });
          } else {
            t.GetFollowUserList();
            t.GetChannelDetail();
            t.GetAllClientTags();
          }
        } else {
          Toast(res.errorMsg);
          setTimeout(() => {
            t.$router.back(-1);
          }, 2000);
        }
      })
      .catch((error) => {
        console.log("error", error);
        // Toast("网络异常，请刷新后重试");
        // setTimeout(() => {
        //   t.$router.back(-1);
        // }, 2000);
      });
    // t.GetFollowUserList();
    // t.GetChannelDetail();
    // t.GetAllClientTags();
    t.userTabs.confimEvent = function() {
      t.userTabs_sel = false;
    };
    t.useuser.closeModal = function() {
      t.useuser_sel = false;
    };
  },
  mounted() {},
};
</script>

<style scoped lang="scss" src="../../static/scss/disdetail.scss"></style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
